module.exports = __webpack_public_path__ + "static/Corporate_Responsibility_03-40c048372d2080ef10b4930013cec8a8.jpg";